module.exports = __webpack_public_path__ + "img/Element_extraction-3.585e5125.png";